import { Minus, Plus } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useNumberSpinner from "common/hooks/useNumberSpinner";

const smVariantButtonClassname =
  "p-2 disabled:text-black-400 hover:bg-black-200 rounded-xl transition-[background]";

export function CountSpinner({
  variant,
  value,
  setValue,
  minValue = 0,
  maxValue,
  maxValueTooltipText,
  inputId,
}: {
  variant: "sm" | "lg";
  value: number;
  setValue: (seatCount: number) => void;
  minValue?: number;
  maxValue: number;
  maxValueTooltipText?: string;
  inputId?: string;
}) {
  const { inputProps, incrementButtonProps, decrementButtonProps } =
    useNumberSpinner(value, setValue, minValue, maxValue);

  const containerClassName =
    variant === "sm"
      ? "flex bg-black-100 border border-black-200 rounded-xl items-center text-black-950 w-fit transition-[background]"
      : "flex h-15 items-center justify-between rounded-4xl bg-white shadow-md px-10";

  const inputClassName =
    variant === "sm"
      ? "w-10 h-7 bg-white shadow-sm rounded-lg p-2 text-center text-button-xs focus-visible:border-purple-500 border focus-visible:outline-none border-white"
      : "rounded-2xl border w-22.5 focus-visible:border-purple-500 border-black-100 bg-black-50 h-9 text-center shadow-[0_2px_4px_0_rgba(0,0,0,0.10)_inset] text-xl-medium focus-visible:outline-none";

  const plusButton =
    variant === "sm" ? (
      <button
        type="button"
        className={smVariantButtonClassname}
        {...incrementButtonProps}
      >
        <Plus className="size-4" />
      </button>
    ) : (
      <Button
        intent="iconOnly"
        variant="secondary-black"
        size="sm"
        {...incrementButtonProps}
      >
        <Plus />
      </Button>
    );

  return (
    <div
      className={
        variant === "lg" &&
        "rounded-5xl border border-black-200 bg-black-50 p-0.75"
      }
    >
      <div className={containerClassName}>
        {variant === "sm" ? (
          <button
            type="button"
            className={smVariantButtonClassname}
            {...decrementButtonProps}
          >
            <Minus className="size-4" />
          </button>
        ) : (
          <Button
            variant="secondary-black"
            size="sm"
            intent="iconOnly"
            {...decrementButtonProps}
          >
            <Minus />
          </Button>
        )}
        <input id={inputId} className={inputClassName} {...inputProps} />
        {value >= maxValue && maxValueTooltipText ? (
          <Tooltip>
            <TooltipTrigger>{plusButton}</TooltipTrigger>
            <TooltipContent>{maxValueTooltipText}</TooltipContent>
          </Tooltip>
        ) : (
          plusButton
        )}
      </div>
    </div>
  );
}
